import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComponentProps } from 'ui/common';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemInvolvedDrugProps extends ComponentProps, FactItemProps {
  numberOfInvolvedDrugs: ChildEntityCountShape;
}

export const InvolvedDrugFactItem = (props: FactItemInvolvedDrugProps) => {
  const { tooltip, title, numberOfInvolvedDrugs, url, linkDomain, portalTarget } = props;
  const iconAbsolutePath = toAbsoluteUrl('i/drug-icon.svg');
  const iconInvolvedDrugs = <Icon url={iconAbsolutePath} />;
  const items = [
    { value: numberOfInvolvedDrugs?.count as number, tooltip }
  ];

  if (!numberOfInvolvedDrugs?.count) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={iconInvolvedDrugs}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
